export default {
  DEFAULT_I18NEXT_NAMESPACE: 'translation',
  DEFAULT_LOCALE: 'en',
};
